import { render, staticRenderFns } from "./topic-content.vue?vue&type=template&id=13bfe07e&scoped=true"
import script from "./topic-content.vue?vue&type=script&lang=js"
export * from "./topic-content.vue?vue&type=script&lang=js"
import style0 from "./topic-content.vue?vue&type=style&index=0&id=13bfe07e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bfe07e",
  null
  
)

export default component.exports